module.exports = __webpack_public_path__ + "static/media/job_wall.341945c4.svg";